<template>
    <div class="main-library">
     
      <main>
        <!-- 表格搜索栏 -->
        <div class="toolbar">
          <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
            <a-form-model-item prop="searchText" >
              <a-input-search v-model.trim="pagination.searchText" placeholder="名称" style="width: 200px;"
                              allow-clear :loading="btnLoad" @input="searchTextChange" @search="searchTextChange" />
            </a-form-model-item>
            <a-form-model-item prop="orgId">
              <a-select v-model="pagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                        :loading="btnLoad" @change="searchChange"  show-search  :filter-option="filterOption">
                <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item >
              <a-button @click="resetSearch" style="width: 74px">重  置</a-button>
            </a-form-model-item>
            <a-form-model-item >
              <a-button v-if="$IA('system:library:upload')" type="primary" icon="upload" @click="handleOpen('上传')">上传
              </a-button>
            </a-form-model-item>
          </a-form-model>

        </div>
        <!-- 数据表格 -->
        <a-table :columns="tableColumns"  bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
          @change="handleTableChange" :scroll="{ y: 560 }">
          <span slot="action" slot-scope="record" class="table-action-box">
           <a-tooltip  content="" v-if="$IA('system:library:view')" title="查看" placement="top" effect="light">
              <i class="table-view"  @click="seeVersionsOpen('查看', record)" ></i>
            </a-tooltip>
        </span>
        </a-table>
      </main>
  
  
      <!-- 库上传 -->
      <a-modal centered  :visible="modalVisible" destroyOnClose :confirm-loading="btnLoad"
         @cancel="fileClose"  :maskClosable="false">

        <template slot="title">
          <span class="el-dialog__title">
            {{modalTitle}}
            <a-tooltip  content="" placement="top" effect="light">
               <template slot="title">
                 <span> 文件命名格式为文件名称_版本号.nupkg,上传后实际库名为库项目名称</span>
               </template>
              <i class="el-icon-warning" style="color: #3471fa;"></i>
            </a-tooltip>
          </span>
        </template>

        <div>
            <h4 style="color: #999;">请选择库文件 | 上传文件不能超过{{this.$cookies.get('uploadLibraryMaxFileSize')}}MB</h4>
          <a-upload name="file" :multiple="false" :action="batchImportApi" 
            :fileList="completeFileList"
            :headers="{ Authorization: $store.state.user.token }" @change="handleUpload">
            <a-button type="primary">
              <a-icon type="upload" /> 点击上传
            </a-button>
          </a-upload>
        </div>
         <template slot="footer">
          <a-button @click="fileClose" type="primary">关闭</a-button>
        </template>
      </a-modal>


    <!-- 操作模态框 -->
    <a-modal centered title="查看库版本" :visible="versionsVisible" :confirm-loading="btnLoad" width="580px"
      @cancel="versionsVisible = false" :footer="null"  :maskClosable="false">
      <a-table :columns="versionsColumns" style="padding-bottom: 20px;"  :data-source="versionsData" :pagination="versionsCondition"
        :loading="versionsLoad" @change="versionsTableChange">
        <span slot="action" slot-scope="record">
          <a-popconfirm placement="topLeft" :disabled="record.status === 0" ok-text="确定" cancel-text="取消" @confirm="deleteSubmit(record)" class="popconBtn">
            <template slot="title" style="padding:0 20px">
              是否要删除选定库版本?
            </template>
            <a-button class="delete-btn" v-if="$IA('system:package:delete')" style="padding: 0 7px;height: 24px;" type="danger" size="small"
              icon="delete" :loading="submitLoad"  :disabled="record.status === 0" >
              删除
          </a-button>
          </a-popconfirm>

          <a-button v-if="$IA('system:library:download')" style="margin-left:5px;height: 24px" type="primary" size="small"
            icon="download" :loading="submitLoad" >
            <a :href="axios.defaults.baseURL + '/library/download' + '?token=' + $store.state.user.token + '&versionId=' + record.id"
                  target="_blank" style="color:#fff ;">下载</a>
          </a-button>
        </span>
      </a-table>
    </a-modal>
    </div>
  </template>
  
  <script>
  
  import {notification} from "ant-design-vue";

  export default {
    data() {
      return {
        btnLoad: false,
        tableLoad: false,
        submitLoad: false,
        pagination: {
          searchText: '',
          pageSize: 10,
          pageNo: 1,
          current: 1,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
        },
        formLayout:"inline",
        queryCondition:{},
        tableColumns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            width: 65,
            align: "center",
            customRender: (text, record, index) => `${index + 1}`,
          },
          {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            scopedSlots: { customRender: "name" },
          },
          {
            title: "部门",
            dataIndex: "orgName",
            key: "orgName",
          },
          {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
          },
          {
            title: "发布时间",
            dataIndex: "createTime",
            key: "createTime",
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 70,
            scopedSlots: { customRender: "action" },
        },
        ],
        tableData: [],
        // 模态框显隐
        modalVisible: false,
        // 模态框标题
        modalTitle: '',
        //部门下拉框
        orgList:[],
        batchImportApi: this.axios.defaults.baseURL + "/library/upload",
        completeFileList:[],
        // 分页参数
        pagCurrent:{},
        versionsPagCurrent:{},
        // 查看版本
        versionsData: [],
        versionsLoad: false,
        versionsVisible: false,
        versionsPagination: {
          libraryId: "",
          searchText: '',
          pageSize: 5,
          pageNo: 1,
          current: 1,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '40'],
          showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
        },
        versionsCondition:{},
        versionsColumns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 60,
            customRender: (text, record, index) => `${index + 1}`,
          },
          {
            title: '版本号',
            dataIndex: 'versionNumber',
            key: 'versionNumber',
          },
          {
            title: '发布时间',
            dataIndex: 'createTime',
            key: 'createTime',
          },
          {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 210,
          scopedSlots: { customRender: "action" },
        },
        ],
      }
    },
    methods: {
      // 搜索
      filterOption(input, option) {
        return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      // 重置搜索
      resetSearch(){
        this.$refs.searchBar.resetFields()
        this.searchChange()
      },
      // 打开模态框
      handleOpen(title, data) {
        this.modalTitle = title
        this.modalVisible = true
      },
      // 清空文件夹退出
      fileClose() {
        this.completeFileList = []
        this.modalVisible = false
        this.handleTableChange(this.pagination)
      },
      // 选择文件上传
      handleUpload(info) {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);

        if (fileList[0].size / 1024 / 1024 >this.$cookies.get('uploadLibraryMaxFileSize')) {

         this.$message.warning('文件大小超过'+this.$cookies.get('uploadLibraryMaxFileSize')+'请重新上传文件');
         return false

        }else{
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.url;
            }
            return file;
          });
          this.completeFileList = fileList;
          if (info.file.status === 'done') {
              switch (info.file.response.code) {
            case 200:
              this.$message.success(info.file.response.message);
              break;
            case 500:
              this.completeFileList.pop()
              this.$message.warning(info.file.response.message);
              break;
            }
          }
        }
      },
      // 打开库版本
      seeVersionsOpen(title, data) {
        this.singleData = data
        this.versionsPagination.libraryId = data.id
        this.versionsVisible = true
        this.searchVersionsChange()
      },
      deleteSubmit(data) {
        this.submitLoad = true;
        this.axios.delete("/library/deleteVersion", {
          params: {
            versionId: data.id,
          },
        })
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.versionsTableChange(this.versionsPagCurrent )
              this.modalVisible = false;
              this.handleTableChange(this.pagCurrent)
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
      },
      // 部门下拉框
      allorgList() {
        this.axios
            .post("/org/findParentOrg",)
            .then((res) => {
              if (res.code === 200) {
                this.orgList = res.data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
      },
      // 搜索
      searchVersionsChange(v) {
        this.versionsCondition = this.$lodash.cloneDeep(this.versionsPagination)
        this.versionsTableAjax()
      },
      // 监听版本翻页
      versionsTableChange(pagination, filters, sorter) {
        this.versionsCondition.pageNo =  pagination.current ? pagination.current : 1
        this.versionsCondition.current = pagination.current ? pagination.current : 1
        this.versionsCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
        this.versionsPagCurrent = pagination ? pagination:this.versionsPagination
        this.versionsTableAjax()
      },
      // 版本翻页请求
      versionsTableAjax(pagination, filters, sorter) {
        this.versionsLoad = true
        this.axios.post('/library/findVersions', this.$qs.stringify(this.versionsCondition)).then((res) => {
          this.versionsLoad = false
          if (res.code === 200) {
            this.versionsData = res.data.records;
            this.versionsCondition.total = res.data.total;
          }
        }).catch((err) => {
          console.log(err);
          this.versionsLoad = false
        })
      },
      // 监听搜索输入框输入
      searchTextChange(val){
        if (window.searchTimer) {
          clearTimeout(searchTimer);
        }
        window.searchTimer = setTimeout(() => {
          this.searchChange(val)
        }, 1200);
      },
      // 搜索
      searchChange(v) {
        this.queryCondition = this.$lodash.cloneDeep(this.pagination)
        this.tableAjax()
      },
      // 监听翻页
      handleTableChange(pagination, filters, sorter) {
        this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
        this.queryCondition.current =  pagination.current ? pagination.current : 1
        this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
        this.pagCurrent = pagination ? pagination:this.pagination
        this.tableAjax()
      },
      // 翻页请求
      tableAjax() {
        this.tableLoad = true
        this.axios.post('/library/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
          this.tableLoad = false
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        }).catch((err) => {
          console.log(err);
          this.tableLoad = false
        })
      },

    },
    beforeMount() {
      this.searchChange();
      this.allorgList()

    },
  }
  </script>
  
  <style lang="scss" scoped>
  .main-library {
  //  background-color: #fff;
  //padding: 0 15px;
  //box-shadow: 0 2px 4px -1px rgb(0 0 0 / 10%), 0 4px 5px 0 rgb(0 0 0 / 7%), 0 1px 10px 0 rgb(0 0 0 / 6%);
  //border-radius: 4px;
  //margin-top: 14px;;
  //


  main {
    margin: 10px 0px 5px 5px ;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      align-items: flex-end;
      margin: -7px -8px 0;
      padding: 16px;
      letter-spacing: 1px;
      background-color: #fff;

      h3 {
        margin-bottom: 0;
        line-height: 20px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 18px;
        //font-weight: bold;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        width: 100%;
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          float: right;
          margin-right: 0px;
          .ant-btn{
            width: 74px;
          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    .img-lc {
      vertical-align: middle;
      margin-right: 5px;
    }
    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      background: url('../../assets/images/Table_action.png') no-repeat center;
      border-radius: 20px;
      vertical-align: top;

      &:active {
        background-color: #D8E6FF;
      }
    }

  }
}
  .delete-btn{
    color: #ffff;
  }
  .delete-btn:hover, .delete-btn:focus{
    color: #fff;
    background-color: #ff7875;
    border-color: #ff7875
  }
  .ant-btn-danger[disabled]{
    color: rgba(0, 0, 0, 0.25);
  }
  </style>